import cx from 'clsx';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import FileTypeIcon from '@components/modals/AttachFilesModal/components/FileTypeIcon/FileTypeIcon';

import { MODAL_NAMES } from '@constants/modalRenderers';

import useTranslation from '@hooks/useTranslation';

import type { IFile } from '@model/file';

import { useModalActions } from '@store/useModalStore';

import style from './style.module.scss';

interface IProps {
  files?: IFile[];
  attachedFilesClassName?: string;
}

const imagesExtensions = { jpg: true, jpeg: true, png: true };

const FilesFieldComponent: React.FC<IProps> = ({ files = [], attachedFilesClassName }) => {
  const { t } = useTranslation();
  const { setActiveModal } = useModalActions();

  if (!files.length) {
    return null;
  }

  const getPreview = (index: number) => {
    const images: { src: string }[] = [];

    files.forEach((file) => {
      if (imagesExtensions[file.extension as keyof typeof imagesExtensions]) {
        images.push({ src: file.url || file.path || '' });
      }
    });

    setActiveModal({ name: MODAL_NAMES.lightboxModal, options: { images, index } });
  };

  return (
    <div className={style.attachedFilesBlock}>
      <div className={style.attachedFilesTitle}>
        {t('Attachments')} ({files.length} {files.length === 1 ? 'file' : 'files'})
      </div>
      <div className={cx(style.attachedFiles, attachedFilesClassName)}>
        {files.map((file, index) =>
          imagesExtensions[file.extension as keyof typeof imagesExtensions] ? (
            <div
              className={style.fileItem}
              title={file.name}
              onClick={() => getPreview(index)}
              key={uuidv4()}
            >
              <div className={style.fileItemPicture}>
                <img src={file.url || file.path} className={style.image} alt={file.name} />
              </div>
              <div className={style.name}>{file.name}</div>
            </div>
          ) : (
            <a
              key={uuidv4()}
              href={file.url}
              target="_blank"
              className={style.fileItem}
              download={file.extension !== 'pdf' ? file.name : false}
            >
              <div className={style.fileItemPicture}>
                <FileTypeIcon file={file} variant="secondary" />
              </div>
              <div className={style.name}>{file.name}</div>
            </a>
          ),
        )}
      </div>
    </div>
  );
};

export default FilesFieldComponent;
